export default {
  absence: {
    absence: "Absence",
    absence_not_justified: "Absence non justifiée",
    absence_waiting_for_validation: "En cours de validation",
    absences_not_justified: "Absences non justifiées",
    absences: "Absences",
    course: "Cours",
    company: "Entreprise",
    add_notification: "Envoyer une notification de nouvelle attestation",
    add_event: "Ajouter un évènement",
    edit_event: "Modifier un évènement",
    delete_event: "Supprimer un évènement",
    delete_recurrence: "Supprimer une récurrence",
    delete_recurrence_sub_title:
      "Êtes-vous sûr de vouloir supprimer cette récurrence et tous ses évènements associés ?",
    delete_recurrence_success: "Récurrence supprimée avec succès !",
    delete_events: "Supprimer des évènements",
    delete_event_sub_title: "Êtes-vous sûr de vouloir supprimer cet évènement ?",
    delete_events_sub_title: "Êtes-vous sûr de vouloir supprimer ces évènements ?",
    delete_event_success: "Évènement supprimé avec succès !",
    copy_event_success: "Évènement copié avec succès !",
    cut_event_success: "Évènement coupé avec succès !",
    delete_events_success: "Évènements supprimés avec succès !",
    post_event: "Évènement ajouté avec succès !",
    list_planning: "Liste des événements",
    list_planning_search: "Rechercher des évènements",
    import_planning: "Importer le planning",
    import_planning_success: "Planning importé avec succès !",
    export_planning: "Exporter le planning",
    export_planning_success: "Planning exporté avec succès !",
    add_absence: "Ajouter une absence(s)",
    edit_absence: "Modifier une absence",
    delete_absence: "Supprimer une absence",
    delete_absences: "Supprimer des absences",
    delete_absence_sub_title: "Êtes-vous sûr de vouloir supprimer cette absence ?",
    delete_absences_sub_title: "Êtes-vous sûr de vouloir supprimer ces absences ?",
    delete_absence_success: "Absence supprimée avec succès !",
    attestation_published_success: "Attestations publiées avec succès !",
    copy_absence_success: "Absence copiée avec succès !",
    cut_absence_success: "Absence coupée avec succès !",
    delete_absences_success: "Absences supprimées avec succès !",
    post_absence: "Absence ajoutée avec succès !",
    list_absences: "Liste des absences",
    list_absences_search: "Rechercher des absences",
    list_attendance_certificate: "Lister les attestions de présence",
    attendance_certificate_export_confirmed: "Attestation de présence exportée avec succès !",
    list_of_attendance_certificate: "Liste des attestations de présence",
    no_attendance_certificate_available: "Il n'y a pas encore de certificat de présence",
    no_attendance_certificate_available_for_month: "Il n'y a de certificat de présence pour le mois de",
    download_certificate: "Télécharger le certificat",
    attendance_certificate_unavailable: "Non disponible",
    import_absences: "Importer les absences",
    import_absences_success: "Absences importées avec succès !",
    publication: "Publication d'attestation",
    absence_ask: "Demande d'autorisation d'absence exceptionnelle",
    display_apprentice_list: "Afficher la liste des",
    hide_apprentice_list: "Masquer la liste des apprentis",
    training_detail: "Voir le détail de la formation",
    apprentice_list: "Liste des",
    personnal_data: "Données personnelles",
    sheet_from: "Fiche de",
    event_moved_success: "Évènement déplacé avec succès !",
    absence_moved_success: "Absence déplacé avec succès !",
    justify: "Justifier",
    justify_many_absence: "Justifier plusieurs de mes absences",
    submit_proof: "Déposer un justificatif d'absence",
    proof_downloaded: "Fichier téléchargé avec succès",
    planning: "Évènement",
    not_justify: "Injustifiée",
    justified: "Justifiée",
    in_progress: "En cours de validation",
    start_date: "Date de début",
    end_date: "Date de fin",
    start_time: "Heure de début",
    end_time: "Heure de fin",
    duration: "Durée",
    type: "Type",
    verify_date: "Veuillez saisir les dates correspondant au justificatif déposé",
    linked_to_planning: "Cette absence est reliée à un événement",
    already_exit: "Une absence existe deja sur cette période",
    context_menu: {
      copy: "Copier",
      cut: "Couper",
      paste: "Coller",
      delete: "Supprimer",
      delete_recurrence: "Supprimer la récurrence",
      modify: "Modifier cet évènement",
      modify_absence: "Modifier cette absence",
      add: "Ajouter un évènement",
      add_absence: "Ajouter une absence",
    },
    actions: {
      planning: "Gestion du planning",
      absences: "Gestion de l'assiduité",
      options: "Options",
    },
    justification: {
      valid: {
        confirmation: "Êtes-vous sûr de vouloir valider cette absence ?",
        success: "Absence validée avec succès",
      },
      invalid: {
        success: "Absence invalidée avec succès !",
      },
      action: {
        unvalid: "Invalider",
      },
      unvalid: "Justificatif non valide",
      status: {
        waiting_for_validation: "En attente de validation",
        to_verify: "À vérifier",
        justify: "Justifier mon absence",
        justified: "Justifiée",
        download: "Télécharger le justificatif de l'absence",
        waiting_proof: "En attente de pièce justificative",
        invalid: "Justification invalide",
      },
      notify_apprentice: "Notifier l'alternant en cas de refus",
    },
    verification: "Vérification de l'absence",
    signature: {
      valid: "Valider",
      unlock: "Déverouiller",
      invalid: "Invalider",
      title: "Émargement",
      former: "Formateur",
      lesson: "Cours",
      establishment: "Établissement",
      component: "Composante",
      address: "Adresse",
      confirmation: "Êtes-vous sûr de vouloir valider cet émargement ?",
      already_validate: "Émargement validé",
      reset: {
        title: "Réinitialiser les absences et présences",
      },
      unlock_signature: {
        confirmation: "Êtes-vous sûr de vouloir dévérouiller cet émargement ?",
        success: "Émargement dévérouillé avec succès !",
      },
      valid_all_signature: "Valider tous les émargements sélectionnés",
      valid_all: {
        title: "Validation d'émargements",
        confirmation: "Êtes-vous sûr de vouloir valider tous ces émargements ?",
        success: "Émargements validés avec succès !",
      },
      reset_absence: {
        confirmation: "Êtes-vous sûr de vouloir réinitialiser toutes les absences et présences de cet événement ?",
        subtitle: "Tous les apprentis seront déplacer dans la colonne 'À définir'",
        success: "Absences et présences réinitialisées avec succès !",
      },
      signed_at: "Signé le :",
    },
    status: {
      title: "Status",
      absents: "Absents",
      to_be_defined: "À définir",
      attendees: "Présents",
      cancel: "Séance annulée",
      all_present: "Tous présents à la séance",
      to_valid: "Émargement à valider",
      no_absence_or_presence: " (aucune absence ou présence)",
      with_absence: "Séance validée avec des absences",
    },
    attendance_management: {
      title: "Gestion des présences",
      external_title: "Gestion des présences avec fiche de signatures",
      transfer_to: {
        absence: "Transférer tous les apprentis dans la colonne absents",
        attendance: "Transférer tous les apprentis dans la colonne présents",
      },
    },
    presence: {
      title: ({ plural }) => plural(["Présence", "Présences"]),
    },
    reason: "Motif de l'absence",
    config: {
      valid: {
        confirmation: "Êtes-vous sur de vouloir valider cette configuration ?",
        success: "Configuration validée avec succès !",
      },
    },
    empty_unjustify: "Aucune absence non justifiée",
  },
};
